import { render, staticRenderFns } from "./tpl-10.vue?vue&type=template&id=28a97f20&scoped=true"
import script from "./tpl-10.vue?vue&type=script&lang=js"
export * from "./tpl-10.vue?vue&type=script&lang=js"
import style0 from "./tpl-10.vue?vue&type=style&index=0&id=28a97f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a97f20",
  null
  
)

export default component.exports